<template>
	<card type="cinc" class="ReCardTaskHelp light">
		<!--div slot="header"></!--div-->
		<!--pre>{{masTaskHelp}}</pre-->
		<div v-for="objTaskHelp in masTaskHelp" :key="'TASKHELPLINK'+objTaskHelp.id">			
			<a :href="objTaskHelp.link" target="_blank" :title="objTaskHelp.desct">{{objTaskHelp.name}}</a>
		</div>
	</card>
</template>

<script>
	export default {
		name: 'ReCardTaskHelp',
		components: {

		},
		props: {
			masTaskHelp: Array,
			findId: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {

		},
	}
</script>
<style scoped>
.white-content .card:not(.card-white) .light {background: transparent; box-shadow: none!important; webkit-box-shadow: none!important;}
</style>
